import { CheckIcon } from '@/components/ui/Icons';

export interface StepDescriptor {
  id: string;
  title: string;
}

/**
 * The signup progress rail. Completed steps are clickable so a registrant can
 * go back and correct something without losing what they have typed.
 */
export function Stepper({
  steps,
  current,
  onJump,
}: {
  steps: StepDescriptor[];
  current: number;
  onJump: (index: number) => void;
}) {
  return (
    <nav aria-label="Signup progress">
      <ol className="flex items-center gap-2">
        {steps.map((step, index) => {
          const done = index < current;
          const active = index === current;

          return (
            <li key={step.id} className="flex flex-1 items-center gap-2">
              <button
                type="button"
                onClick={() => done && onJump(index)}
                disabled={!done}
                aria-current={active ? 'step' : undefined}
                className={`flex flex-1 flex-col gap-2 text-left ${done ? 'cursor-pointer' : 'cursor-default'}`}
              >
                <span
                  className={`h-1.5 rounded-full transition-colors duration-300 ${
                    done ? 'bg-safe-500' : active ? 'bg-brand-gradient' : 'bg-slate-200'
                  }`}
                />
                <span className="flex items-center gap-1.5">
                  <span
                    className={`inline-flex size-5 shrink-0 items-center justify-center rounded-full text-[0.65rem] font-bold ${
                      done
                        ? 'bg-safe-100 text-safe-700'
                        : active
                          ? 'bg-brand-600 text-white'
                          : 'bg-slate-100 text-slate-400'
                    }`}
                  >
                    {done ? <CheckIcon className="size-3" /> : index + 1}
                  </span>
                  <span
                    className={`hidden text-xs font-semibold sm:inline ${
                      active ? 'text-ink' : 'text-slate-400'
                    }`}
                  >
                    {step.title}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
